import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { getFlexSelectCustomStyle } from '../../assets/styles/multiple_select';

const FlexSelect = ({
  style = {},
  dataOptions,
  value,
  fieldName,
  placeholder = 'Selecione...',
  valueController,
  isMulti = false,
  labelName,
  valueName,
  closeMenuOnSelect = false,
  isClearable = false,
  isSearchable = true,
  isDisabled = false,
  minHeight = '',
  noOptionsMessage = () => 'Nenhuma Opção',
  tabIndex = 0,
  portalTarget = false,
  onChange = (values) => {}
}) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let arrayOptions = [];
    dataOptions.forEach((option) => {
      arrayOptions.push({
        label: option[labelName],
        value: option[valueName]
      });
    });
    setOptions([...arrayOptions]);
  }, [dataOptions, labelName, valueName]);

  const getSelectValues = (values) => {
    if (isMulti) {
      if (typeof values === 'string') {
        values = values.split(';');
      }
      let capsule = [];
      values.length > 0 &&
        values.forEach((el) => {
          dataOptions.forEach((option) => {
            if (option[valueName] === el)
              capsule.push({
                label: option[labelName],
                value: option[valueName]
              });
          });
        });
      return capsule;
    } else {
      let capsule = [];
      dataOptions.forEach((option) => {
        if (option[valueName] === values)
          capsule.push({
            label: option[labelName],
            value: option[valueName]
          });
      });
      return capsule;
    }
  };

  const controlChange = (values) => {
    if (isMulti) {
      if (values && values.length > 0) {
        const a = values.map((l) => l.value);
        onChange(a);
        return valueController(fieldName, a);
      }
      onChange([]);
      return valueController(fieldName, []);
    } else {
      if (values) {
        onChange(values.value);
        return valueController(fieldName, values.value);
      }
      onChange(null);
      return valueController(fieldName, '');
    }
  };

  return (
    <>
      <Select
        isSearchable={isSearchable}
        tabIndex={tabIndex}
        isClearable={isClearable}
        isMulti={isMulti}
        name={fieldName}
        placeholder={placeholder}
        styles={{ ...getFlexSelectCustomStyle({ minHeight }), ...style }}
        value={getSelectValues(value)}
        onChange={controlChange}
        closeMenuOnSelect={closeMenuOnSelect}
        classNamePrefix="react-select"
        options={options}
        isDisabled={isDisabled}
        noOptionsMessage={noOptionsMessage}
        menuPortalTarget={portalTarget ? document.body : null}
      />
    </>
  );
};

export default FlexSelect;
